<template lang="pug">
.box
    v-server-table(
        ref="datatable" 
        :url="api" 
        :name="tableName" 
        :columns="columns" 
        :options="options"
    )

    aside-modal(id="createPricebook", ref="modal", :loading="onLoading('save-pricebook')")
        template(slot="header-text") Create Pricebook
        template(slot="footer")
            button.btn.btn-fw.green(
                @click="submit",
                :disabled="onLoading('save-pricebook')"
            )
                v-loading(loader="save-pricebook") Create
        template(slot="body")
            form(@submit.prevent="")
                fieldset(:disabled="onLoading('save-pricebook')")
                    .padding
                        .form-group
                            label Name
                            input.form-control(
                                v-validate="'required'", 
                                :value="pricebook.name",
                                :disabled="onLoading('save-pricebook')",
                                type="text",
                                class="form-control",
                                name="name",
                                placeholder="Required",
                                @input="setPricebookAttr({ key: 'name', value: $event.target.value })"
                            )

                        .form-group
                            label Outlets
                            multi-outlet-selector(
                                :value="pricebook.outlets",
                                :disabled="onLoading('save-pricebook')",
                                v-model="outlets",
                                :include-only="allowedOutlets"
                            )
    aside-modal(id="hidePricebook", ref="hide")
        template(slot="header-text") Hide Pricebook
        template(slot="footer")
          button.btn.btn-fw.green(
            @click="submitBulkHide",
          )
            v-loading(loader="save-pricebook") Save
        template(slot="body")
            form(@submit.prevent="")
              fieldset(:disabled="onLoading('save-pricebook')")
                .padding
                  .form-group
                    label Hide Pricebook
                      p
                        label.md-switch
                          input.has-value(v-model='pricebook.status' type='checkbox')
                          i.indigo
                            | Hide tag
                      p  The tag will hidden from Central and Waiter.
</template>

<script>
import Auth from '@js/plugins/auth';

const TableName = 'VUETABLE_PRICEBOOK';
import { mapActions, mapGetters } from 'vuex';
import pricebookModule from '@js/store/modules/pricebook';
import { Event } from '../../../event-bus';

export default {
    props: {
        allowedOutlets: {
            type: Array,
            required: true,
        },
    },

    data: function() {
        var that = this;
        let canManagePricebook = Auth.hasPermissionTo(
            'franchise_manage_pricebooks',
        );

        let actionButtons = [
            {
                title: 'Create Pricebook',
                action: () => {
                    this.$refs.modal.$emit('show');
                },
            },
            {
                title: 'Archive Pricebook',
                action: () => this.showArchive(),
            },
        ];

        if (!canManagePricebook) {
            actionButtons = [];
        }

        return {
            tag: {},
            tableName: TableName,
            api: Laroute.route('franchise.inventory.pricebook.index'),
            columns: ['name', 'products', 'outlets'],
            options: {
                checkbox: canManagePricebook,
                checkboxActions: [
                    {
                        title: 'Hide Pricebooks',
                        callback: () => {
                            this.submitBulkHide();
                        },
                    },
                ],
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.pricebook.delete',
                    ),
                    delete_title: 'Delete Pricebooks',
                },
                customFilters: ['outlet_id'],
                initFilters: { outlet_id: that.$store.getters.activeOutlet },
                sortable: ['name'],
                orderBy: { column: 'name', ascending: 1 },
                perPageValues: [5, 10, 20, 40, 80],
                templates: {
                    products(h, row) {
                        return require('./product.jsx')(h, row);
                    },
                    outlets(h, row) {
                        return require('./outlet.jsx')(h, row);
                    },
                },
                actionButtons: actionButtons,
                rowClassCallback: row => 'pointer',
                rowClickCallback: that.showPricebook,
            },
        };
    },

    computed: {
        ...mapGetters('pricebook', ['pricebook']),

        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },

        outlets: {
            get() {
                return this.pricebook.outlets;
            },
            set(value) {
                this.setPricebookAttr({ key: 'outlets', value });
            },
        },
    },

    watch: {
        activeOutlet: function() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: this.activeOutlet,
            });
        },
    },

    beforeCreate() {
        this.$store.registerModule('pricebook', pricebookModule);
    },

    methods: {
        ...mapActions('pricebook', [
            'setPricebookAttr',
            'createPricebook',
            'bulkHidePricebook',
        ]),

        showPricebook(pricebook) {
            window.location.href = Laroute.route(
                'franchise.inventory.pricebook.edit',
                { id: pricebook.id },
            );
        },

        bulkHide() {
            $('#hidePricebook').modal('show');
        },

        bulkData() {
            let payload = {
                ids: this.$store.getters[
                    'VUETABLE_PRICEBOOK_CHECKBOX/getSelected'
                ],
            };
            payload.status = 0;
            return payload;
        },

        submitBulkHide() {
            this.bulkHidePricebook(this.bulkData())
                .then(u => {
                    this.refresh();
                    let res = u.data;
                    if (res.not_allowed.length > 0) {
                        if (res.not_allowed.length === 1) {
                            this.showToastrError(
                                'The pricebook ' +
                                    res.not_allowed[0].name +
                                    ' has been assigned to the selected outlet and cannot be hidden',
                            );
                        } else {
                            this.showToastrError(
                                res.not_allowed.length +
                                    ' pricebooks have been assigned to the selected outlet and cannot be hidden',
                            );
                        }
                    } else {
                        this.showToastrSuccess(
                            'The selected pricebook successfully hide',
                        );
                    }
                })
                .catch(e => {});
        },

        async submit() {
            const validate = await this.$validator.validate();

            if (!validate) return;

            try {
                const pricebook = await this.createPricebook();
                this.showPricebook(pricebook);
            } catch (e) {
                this.showApiError(e);
            }
        },

        refresh() {
            this.$refs.datatable.getData();
        },

        showArchive() {
            window.location.href = Laroute.route(
                'franchise.inventory.pricebook.archive',
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/pricebook/index.vue